import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49e401f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child" }
const _hoisted_5 = { class: "card has-table has-mobile-sort-spaced" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Estadísticas generales ")
], -1))
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-small is-info",
  max: "100"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "is-flex is-justify-content-space-between is-flex-wrap-wrap has-text-centered" }
const _hoisted_13 = { class: "custom-font-style-value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "custom-font-style-title" }, " Instituciones disponibles ", -1))
const _hoisted_15 = { class: "custom-font-style-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "custom-font-style-title" }, " Documentos y registros ", -1))
const _hoisted_17 = { class: "custom-font-style-value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "custom-font-style-title" }, " Descargas de documentos ", -1))
const _hoisted_19 = { class: "capitalize custom-font-style-value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "custom-font-style-title" }, " Último mes actualizado ", -1))


import Statistics from "@/entities/statistics";

interface Props {
  statistics: Statistics;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    statistics: null
  },
  setup(__props: any) {

const props = __props as {
  statistics: Statistics;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (!__props.statistics.entities)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(props.statistics.entities), 1),
                          _hoisted_14
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(props.statistics.all_submission_files), 1),
                          _hoisted_16
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(props.statistics.files_downloaded), 1),
                          _hoisted_18
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(props.statistics.last_month_updated), 1),
                          _hoisted_20
                        ])
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})